import { Typography } from "@mui/material";

import { TimePointsLabel } from "@/constants/timeRange";

import { useFilterContext } from "../FilterContext";
import FilterTimeSlider from "../components/FilterTimeSlider";

const FilterItemPoints = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();

  const formatLabel = (value: number) => {
    return TimePointsLabel[filterOptions.commonTimeRange[value]];
  };

  return (
    <div className="pt-[40px] pb-[12px] px-[40px] space-y-[20px]">
      <div className="space-y-[50px]">
        <Typography color="textPrimary">Departure Time:</Typography>
        <FilterTimeSlider
          getAriaValueText={formatLabel}
          valueLabelFormat={formatLabel}
          value={[filterData.times[0], filterData.times[1]]}
          onChange={(v) => {
            setFilterData({
              times: [...v, filterData.times[2], filterData.times[3]],
            });
          }}
        />
      </div>

      <div className="space-y-[50px]">
        <Typography color="textPrimary">Arrival Time:</Typography>
        <FilterTimeSlider
          getAriaValueText={formatLabel}
          valueLabelFormat={formatLabel}
          value={[filterData.times[2], filterData.times[3]]}
          onChange={(v) => {
            setFilterData({
              times: [filterData.times[0], filterData.times[1], ...v],
            });
          }}
        />
      </div>
    </div>
  );
};

export default FilterItemPoints;
